import React from 'react';
import Hero from '../components/Hero';
import OurStrengthsSection from '../components/OurStrengthsSection';
import StatsSection from '../components/StatsSection';
import CtaSection from '../components/CtaSection';
import BlogSection from '../components/BlogSection';
import TechStackSection from '../components/TechStackSection';
import aiTrends from '../assets/blog/AI trends 2025.webp';
import cloudSecurity from '../assets/blog/cloud security 225.jpg';
import mobileCover from '../assets/blog/cover-mobile-ux-design-best-practices.png';

import Speed from "../assets/lottie/speed-lottie.json";
import TechSavyTeam from "../assets/lottie/tech-savy-team-lottie.json";
import LeanTeam from "../assets/lottie/lean-team-lottie.json";
import Investor from "../assets/lottie/investor-lottie.json";

import Process from '../components/Process';
import Lottie from 'lottie-react';
import Services from '../components/Services';
import SolutionsSection from '../components/SolutionsSection';
import TestimonialsSectionV2 from '../components/TestimonialsSectionV2';

const HomePage: React.FC = () => {
  // Sample AI services data
  const ourStrengths = [
    {
      title: 'Launch in Weeks, Not Months',
      description: 'Get to market fast and start validating with real users.',
      icon: <Lottie animationData={Speed} />,
      color: 'blue'
    },
    {
      title: 'Your Extended Technical Team',
      description: "Technical founder? We amplify your capabilities. Non-technical? We become your technical partner. Either way, you focus on what you do best.",
      icon: <Lottie animationData={TechSavyTeam} />,
      color: 'indigo'
    },
    {
      title: 'Smart Resource Allocation',
      description: 'Every founder faces resource constraints. We help you build the right features first and scale efficiently as you grow.',
      icon: <Lottie animationData={LeanTeam} />,
      color: 'purple'
    },
    {
      title: 'Investor & Market Ready',
      description: 'Build products that impress both investors and users. Technical architecture that scales, UX that converts, metrics that matter.',
      icon: <Lottie animationData={Investor} />,
      color: 'teal'
    }
  ];

  // Sample stats data
  const stats = [
    {
      value: '50+',
      label: 'Startups Launched'
    },
    {
      value: '100+',
      label: 'SMEs Transformed'
    },
    {
      value: '4-8',
      label: 'Weeks to MVP'
    },
    {
      value: '98%',
      label: 'Client Satisfaction'
    }
  ];

  // Sample blog posts data
  const blogPosts = [
    {
      id: 'ai-trends-2025',
      title: 'Top AI Trends to Watch in 2025',
      excerpt: 'Explore the emerging trends in artificial intelligence that are reshaping industries and creating new opportunities for businesses.',
      category: 'AI',
      date: 'May 5, 2025',
      author: 'Emily Chen',
      imageUrl: aiTrends
    },
    {
      id: 'cloud-security',
      title: 'Best Practices for Cloud Security in 2025',
      excerpt: 'Learn how to protect your cloud infrastructure with these essential security practices that every business should implement.',
      category: 'Cloud',
      date: 'April 28, 2025',
      author: 'Robert Jackson',
      imageUrl: cloudSecurity
    },
    {
      id: 'mobile-app-design',
      title: 'Mobile App Design Trends for Enhanced User Experience',
      excerpt: 'Discover the latest design trends that are improving user experience and driving engagement in mobile applications.',
      category: 'Design',
      date: 'April 15, 2025',
      author: 'Sophie Williams',
      imageUrl: mobileCover
    }
  ];

  return (
    <>
      <Hero
        title="We Build Fast, Scalable MVPs for Founders Who Want to Go From Idea to Demo in 60 Days"
        subtitle="Stop getting stuck in development hell. We're the technical partner founders wish they had helping you build, launch, and scale without the headaches."
        buttonText="Get Started"
        buttonLink="/contact"
        secondaryButtonText="Our Services"
        secondaryButtonLink="/services"
        backgroundStyle="gradient"
      />

      <SolutionsSection />
      
      <Services 
      mvpLink={'/mvp-development'}
      smeLink={'/digital-transformation'}
      webDevLink={'/services#web'}
      mobileDevLink={'/services#mobile'}
      uiLink={''}
      analyticsLink={'/ai-services'}
      aiLink={'/ai-services'}
       />
      
      <OurStrengthsSection strengths={ourStrengths} />

      <Process />
      
      <StatsSection
        title="Results That Matter to Founders"
        subtitle="Track record of helping founders succeed in their 0-1 journey"
        stats={stats}
        sectionStyle="dark"
      />

      <TechStackSection
        title="Enterprise-Grade Technology"
        subtitle=" We use the same tools that power billion-dollar companies, optimized for your scale and budget"
      />

      <TestimonialsSectionV2 />
            
      <BlogSection
        title="Latest Insights"
        subtitle="Stay updated with the latest trends and insights in technology and AI."
        posts={blogPosts}
      />

      
      <CtaSection
        title="Ready to Turn Your Idea Into Reality?"
        subtitle="Join 50+ founders who chose us as their technical partner. Let's build your product and get you investor-ready in 60 days."
        buttonText="Start Building Today"
        buttonLink="/contact"
        sectionStyle="gradient"
      />
    </>
  );
};

export default HomePage;